"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkLessonIsReleased = void 0;
const moment = require("moment");
exports.checkLessonIsReleased = (releaseDate) => moment().diff(moment(releaseDate).startOf('day')) >= 0;
